import { TableCell, TableHead, TableRow } from "@mui/material";
import useLocales from "src/hooks/useLocales";

export const TableHeader = () => {
	const { translate } = useLocales();
	return (
		<TableHead>
			<TableRow>
				<TableCell>{translate("api_client.name")}</TableCell>
				<TableCell align='left'>{translate("api_client.redirect_uri")}</TableCell>
				<TableCell align='left'>{"Token"}</TableCell>
				<TableCell align='right'>{""}</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default TableHeader;
